import React, { useState } from 'react';
import Header from '../component/Header';
import CommonBanner from '../component/CommonBanner';
import Footer from '../component/Footer';
import { Button, Col, Container, Row, Modal, Form } from 'react-bootstrap';
import EditIcon from '../assets/images/edit-red.svg';
import DeleteIcon from '../assets/images/delete-red.svg';
import DeletIconTwo from  '../assets/images/delete.svg';
import { Link } from 'react-router-dom';

function SavedSearches() {
  const [searches, setSearches] = useState([
    {
      id: 1,
      title: 'For Sale in New York',
      location: 'For Sale',
      type: 'sale',
    },
    {
      id: 2,
      title: 'For Rent in New York',
      location: 'For Rent',
      type: 'rent',
    },
    {
      id: 3,
      title: 'For Sale in New York',
      location: 'For Sale',
      type: 'sale',
    },
    {
      id: 4,
      title: 'For Rent in New York',
      location: 'For Rent',
      type: 'rent',
    },
  ]);

  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedSearch, setSelectedSearch] = useState(null);
  const [editFormData, setEditFormData] = useState({
    name: '',
    subscription: '',
    state: '',
  });

  const handleEditClick = (search) => {
    setSelectedSearch(search);
    setEditFormData({
      name: search.title,
      city: 'New York',
      state: 'NY',
      keyword: '',
    });
    setShowEditModal(true);
  };

  const handleDeleteClick = (search) => {
    setSelectedSearch(search);
    setShowDeleteModal(true);
  };

  const handleEditClose = () => {
    setShowEditModal(false);
    setSelectedSearch(null);
  };

  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setSelectedSearch(null);
  };

  const handleEditSave = () => {
    console.log('Saving edit:', editFormData);
    // Update the search in the list
    setSearches(
      searches.map((s) =>
        s.id === selectedSearch.id ? { ...s, title: editFormData.name } : s
      )
    );
    handleEditClose();
  };

  const handleDeleteConfirm = () => {
    console.log('Deleting search:', selectedSearch);
    setSearches(searches.filter((s) => s.id !== selectedSearch.id));
    handleDeleteClose();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditFormData({ ...editFormData, [name]: value });
  };

  return (
    <>
      <div className="main saved-searches-page">
        <Header />
        <CommonBanner title="Saved Searches" />
        <section className="saved-searches-section common-padding">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="searches-list">
                  {searches.map((search) => (
                    <div key={search.id} className="search-item">
                      <div className="search-content">
                        <h3>{search.title}</h3>
                        <p>{search.location}</p>
                      </div>
                      <div className="search-actions">
                        <Button
                          variant="link"
                          className="edit-btn"
                          onClick={() => handleEditClick(search)}
                        >
                          <img src={EditIcon} alt='' /> Edit
                        </Button>
                        <Button
                          variant="link"
                          className="delete-btn"
                          onClick={() => handleDeleteClick(search)}
                        >
                          <img src={DeleteIcon} alt='' /> Delete
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <Footer />
      </div>

      {/* Edit Modal */}
      <Modal
        show={showEditModal}
        onHide={handleEditClose}
        centered
        className="edit-search-modal"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title>Edit saved search</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={5}>
              <div
                  className="around-map overflow-hidden"
                >
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d3024.4523889567754!2d-74.0060!3d40.7199!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1234567890"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Around This Home Map"
                  ></iframe>
                </div>
            </Col>
            <Col md={7}>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Name <span>*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={editFormData.name}
                    onChange={handleInputChange}
                    placeholder="Enter name"
                  />
                </Form.Group>
                <Form.Group className="mb-3 d-flex justify-content-between align-items-center">
                  <Form.Label className='mb-0'>For Sale</Form.Label>
                  <Form.Check 
                    type="switch"
                    id="push-switch"
                    className="custom-switch"
                    defaultChecked={true}
                  />
                </Form.Group>
              </Form>
              <Form.Group className="mb-3">
                    <Form.Label>Subscription</Form.Label>
                    <Form.Select
                      value={editFormData.subscription}
                    onChange={handleInputChange}
                    >
                      <option>Instant</option>
                      <option>Instant 2</option>
                      <option>Instant 3</option>
                      <option>Instant 4</option>
                      <option>Instant 5</option>
                    </Form.Select>
                </Form.Group>
            </Col>
          </Row>
          <div className="m-footer d-flex justify-content-between align-items-center">
            <Link to={''} onClick={handleEditClose}>Delete</Link>
            <div className='d-flex align-items-center gap-4'>
              <Button className="custom-bttn style-2" onClick={handleEditClose}>
                Cancel
              </Button>
              <Button className="custom-bttn style-3" onClick={handleEditSave}>
                Update
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        show={showDeleteModal}
        onHide={handleDeleteClose}
        centered
        className="delete-search-modal"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-icon">
            <img src={DeletIconTwo} alt='' />
          </div>
          <h4>Are you sure?</h4>
          <p>Deleting your search removes it from your web and app experience. Any email subscriptions and app notifications related to this search will also be removed.</p>
          <div className="m-footer d-flex justify-content-center align-items-center gap-4">
          <Button className="custom-bttn style-2" onClick={handleDeleteClose}>
            Cancel
          </Button>
          <Button className="custom-bttn" onClick={handleDeleteConfirm}>
            Delete
          </Button>
        </div>
        </Modal.Body>
        
      </Modal>
    </>
  );
}

export default SavedSearches;